import { computed, makeObservable, observable } from 'mobx'
import moment from 'moment'
import { createIntl } from 'react-intl'
import agreementStatus0 from '../assets/images/agreementCheckingStatuses/agreement-checking-status-0.svg'
import agreementStatus1 from '../assets/images/agreementCheckingStatuses/agreement-checking-status-1.svg'
import createDateIcon from '../assets/images/common/creationDate.svg'
import installationDateIcon from '../assets/images/common/installationDate.svg'
import accepted from '../assets/images/orderStatuses/accepted.svg'
import assigned from '../assets/images/orderStatuses/assigned.svg'
import forRevision from '../assets/images/orderStatuses/clarify_request.svg'
import duplicate from '../assets/images/orderStatuses/duplicate.svg'
import incomplete from '../assets/images/orderStatuses/incomplete.svg'
import installation from '../assets/images/orderStatuses/installation.svg'
import installed from '../assets/images/orderStatuses/installed.svg'
import newRequest from '../assets/images/orderStatuses/new.svg'
import uploadByAdmin from '../assets/images/orderStatuses/uploadByAdmin.svg'
import closed from '../assets/images/reportStatuses/closed.svg'
import dataChecking from '../assets/images/reportStatuses/dataChecking.svg'
import dataCheckFinished from '../assets/images/reportStatuses/dataCheckingFinished.svg'
import dataClarifying from '../assets/images/reportStatuses/dataClarifying.svg'
import dataRechecking from '../assets/images/reportStatuses/dataRechecking.svg'
import formed from '../assets/images/reportStatuses/formed.svg'
import paying from '../assets/images/reportStatuses/paying.svg'
import received from '../assets/images/reportStatuses/received.svg'
import sent from '../assets/images/reportStatuses/sent.svg'
import serviceFormed from '../assets/images/service-report-statuses/service-report-1.svg'
import serviceReceived from '../assets/images/service-report-statuses/service-report-100.svg'
import serviceDataRechecking from '../assets/images/service-report-statuses/service-report-101.svg'
import servicePaying from '../assets/images/service-report-statuses/service-report-102.svg'
import serviceDataCheckFinished from '../assets/images/service-report-statuses/service-report-14.svg'
import serviceDataChecking from '../assets/images/service-report-statuses/service-report-2.svg'
import serviceClosed from '../assets/images/service-report-statuses/service-report-200.svg'
import serviceDataClarifying from '../assets/images/service-report-statuses/service-report-3.svg'
import serviceSent from '../assets/images/service-report-statuses/service-report-5.svg'
import acceptedByDealerIcon from '../assets/images/serviceOrderStatuses/acceptedByDealer.svg'
import dealerAssigned from '../assets/images/serviceOrderStatuses/dealerAssigned.svg'
import diagnosticAndRepairIcon from '../assets/images/serviceOrderStatuses/diagnosticAndRepair.svg'
import duplicateIcon from '../assets/images/serviceOrderStatuses/duplicate.svg'
import guaranteeRepairIcon from '../assets/images/serviceOrderStatuses/guaranteeRepair.svg'
import impossibleIcon from '../assets/images/serviceOrderStatuses/impossible.svg'
import improvementRequiredIcon from '../assets/images/serviceOrderStatuses/improvementRequired.svg'
import inProgress from '../assets/images/serviceOrderStatuses/inProgress.svg'
import repairIsDoneIcon from '../assets/images/serviceOrderStatuses/repairIsDone.svg'
import requested from '../assets/images/serviceOrderStatuses/requested.svg'
import solvedWithoutVisitIcon from '../assets/images/serviceOrderStatuses/solvedWithoutVisit.svg'
import status20 from '../assets/images/serviceOrderStatuses/status-20.svg'
import status22 from '../assets/images/serviceOrderStatuses/status-22.svg'
import status23 from '../assets/images/serviceOrderStatuses/status-23.svg'
import status24 from '../assets/images/serviceOrderStatuses/status-24.svg'
import status30 from '../assets/images/serviceOrderStatuses/status-30.svg'
import status6 from '../assets/images/serviceOrderStatuses/status-6.svg'
import status8 from '../assets/images/serviceOrderStatuses/status-8.svg'
import ticketStatus5 from '../assets/images/serviceOrderStatuses/ticket-5.svg'
import status21 from '../assets/images/serviceOrderStatuses/toGuaranteeRepair.svg'
import transferToServiceCenterIcon from '../assets/images/serviceOrderStatuses/transferToServiceCenter.svg'
import { getIconFinancialSource } from '../helpers/switchFinancialSource'
import {
  isAdmin,
  isAdministration,
  isDealer,
  isDealerOperator,
  isOperator,
} from '../services/AccountService'
import { getFinancialSources } from '../services/ApiService'
import { intlConfig } from '../utils/consts/intlConfig'

class StatusesStore {
  constructor() {
    this.intl = createIntl(intlConfig)
    this.reportOrderStatuses = [
      {
        id: this.allOrderStatuses.reporting,
        name: this.intl?.formatMessage({ id: 'Добавлена в отчет' }),
        imageSrc: formed,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Количество заявок, переведённых за указанный период в статус "Добавлена в отчет"',
        }),
      },
      {
        id: this.allOrderStatuses.dataChecking,
        name: this.intl?.formatMessage({ id: 'Проверка данных' }),
        imageSrc: dataChecking,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Количество заявок, переведённых за указанный период в статус "Проверка данных"',
        }),
      },
      {
        id: this.allOrderStatuses.clarifying,
        name: this.intl?.formatMessage({ id: 'Уточнение данных' }),
        imageSrc: dataClarifying,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Количество заявок, переведённых за указанный период в статус "Уточнение данных"',
        }),
      },
      {
        id: this.allOrderStatuses.reported,
        name: this.intl?.formatMessage({ id: 'Проверка завершена' }),
        imageSrc: dataCheckFinished,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Количество заявок, переведённых за указанный период в статус "Проверка завершена"',
        }),
      },
      {
        id: this.allOrderStatuses.closed,
        name: this.intl?.formatMessage({ id: 'Завершена' }),
        imageSrc: closed,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Количество заявок, переведённых за указанный период в статус "Завершена"',
        }),
      },
    ]

    this.reportServiceOrderStatuses = [
      {
        id: this.allServiceOrderStatuses.requested,
        name: this.intl?.formatMessage({ id: 'Создана' }),
        imageSrc: requested,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Создана',
        }),
      },
      {
        id: this.allServiceOrderStatuses.dealerAssigned,
        name: this.intl?.formatMessage({ id: 'Назначена' }),
        imageSrc: dealerAssigned,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Назначена',
        }),
      },
      {
        id: this.allServiceOrderStatuses.solvedWithoutVisit,
        name: this.intl?.formatMessage({ id: 'Выполнена дистанционно' }),
        imageSrc: solvedWithoutVisitIcon,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Выполнена дистанционно',
        }),
      },
      {
        id: this.allServiceOrderStatuses.acceptedByDealer,
        name: this.intl?.formatMessage({ id: 'Принята' }),
        imageSrc: acceptedByDealerIcon,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Принята',
        }),
      },
      {
        id: this.allServiceOrderStatuses.InProgress,
        name: this.intl?.formatMessage({ id: 'В работе' }),
        imageSrc: inProgress,
        summaryTooltip: this.intl?.formatMessage({
          id: 'В работе',
        }),
      },
      {
        id: this.allServiceOrderStatuses.impossible,
        name: this.intl?.formatMessage({ id: 'Обслуживание не выполнено' }),
        imageSrc: impossibleIcon,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Обслуживание не выполнено',
        }),
      },
      {
        id: this.allServiceOrderStatuses.duplicate,
        name: this.intl?.formatMessage({ id: 'Дубликат' }),
        imageSrc: duplicateIcon,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Дубликат',
        }),
      },
      {
        id: 30,
        name: this.intl?.formatMessage({
          id: 'Отказ абонента',
        }),
        imageSrc: status30,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Отказ абонента',
        }),
      },
      {
        id: this.allServiceOrderStatuses.improvementRequired,
        name: this.intl?.formatMessage({ id: 'На доработку' }),
        imageSrc: improvementRequiredIcon,
        summaryTooltip: this.intl?.formatMessage({
          id: 'На доработку',
        }),
      },
      //  Комплексные статусы

      {
        id: this.allServiceOrderStatuses.repairIsDone,
        name: this.intl?.formatMessage({ id: 'Выполнен негарантийный ремонт' }),
        imageSrc: repairIsDoneIcon,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Выполнен негарантийный ремонт',
        }),
      },
      {
        id: this.allServiceOrderStatuses.toGuaranteeRepair,
        name: this.intl?.formatMessage({ id: 'В обработке у офиса' }),
        imageSrc: status8,
        summaryTooltip: this.intl?.formatMessage({
          id: 'В обработке у офиса',
        }),
      },
      {
        id: this.allServiceOrderStatuses.guaranteeRepairSended,
        name: this.intl?.formatMessage({ id: 'Ремонт по гарантии' }),
        imageSrc: status20,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Ремонт по гарантии',
        }),
      },
      {
        id: this.allServiceOrderStatuses.guaranteeRepairStarted,
        name: this.intl?.formatMessage({ id: 'Обслуживание СЦ' }),
        imageSrc: status21,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Обслуживание СЦ',
        }),
      },
      {
        id: this.allServiceOrderStatuses.guaranteeRepairCompleted,
        name: this.intl?.formatMessage({ id: 'Обслужено сервис-центром' }),
        imageSrc: status22,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Обслужено сервис-центром',
        }),
      },
      {
        id: this.allServiceOrderStatuses.guaranteeRepairRejected,
        name: this.intl?.formatMessage({ id: 'Отказано в гарантии' }),
        imageSrc: status23,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Отказано в гарантии',
        }),
      },
      {
        id: 24,
        name: this.intl?.formatMessage({
          id: 'На доработку из СЦ',
        }),
        imageSrc: status24,
        summaryTooltip: this.intl?.formatMessage({
          id: 'На доработку из СЦ',
        }),
      },

      // для фильтров
      {
        id: this.allServiceOrderStatuses.completeRepair,
        name: this.intl?.formatMessage({ id: 'Выполнено обслуживание' }),
        imageSrc: status6,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Выполнено обслуживание',
        }),
      },
      // воображаемые статусы
      {
        id: this.allServiceOrderStatuses.onSiteRepair,
        name: this.intl?.formatMessage({ id: 'Негарантийный ремонт' }),
        imageSrc: diagnosticAndRepairIcon,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Негарантийный ремонт',
        }),
      },
      {
        id: this.allServiceOrderStatuses.transferToServiceCenter,
        name: this.intl?.formatMessage({ id: 'Передача в сервис-центр' }),
        imageSrc: transferToServiceCenterIcon,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Передача в сервис-центр',
        }),
      },
      {
        id: this.allServiceOrderStatuses.guaranteeRepair,
        name: this.intl?.formatMessage({ id: 'Выполнен гарантийный ремонт' }),
        imageSrc: guaranteeRepairIcon,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Выполнен гарантийный ремонт',
        }),
      },
      {
        id: this.allServiceOrderStatuses.noGuaranteeRepair,
        name: this.intl?.formatMessage({
          id: 'Отказ в гарантийном ремонте',
        }),
        imageSrc: ticketStatus5,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Отказ в гарантийном ремонте',
        }),
      },

      // отчетные статусы
      {
        id: this.allOrderStatuses.reporting,
        name: this.intl?.formatMessage({ id: 'Добавлена в отчет' }),
        imageSrc: serviceFormed,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Количество заявок, переведённых за указанный период в статус "Добавлена в отчет"',
        }),
      },
      {
        id: this.allOrderStatuses.dataChecking,
        name: this.intl?.formatMessage({ id: 'Проверка данных' }),
        imageSrc: serviceDataChecking,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Количество заявок, переведённых за указанный период в статус "Проверка данных"',
        }),
      },
      {
        id: this.allOrderStatuses.clarifying,
        name: this.intl?.formatMessage({ id: 'Уточнение данных' }),
        imageSrc: serviceDataClarifying,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Количество заявок, переведённых за указанный период в статус "Уточнение данных"',
        }),
      },
      {
        id: this.allOrderStatuses.reported,
        name: this.intl?.formatMessage({ id: 'Проверка завершена' }),
        imageSrc: serviceDataCheckFinished,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Количество заявок, переведённых за указанный период в статус "Проверка завершена"',
        }),
      },
      {
        id: this.allOrderStatuses.closed,
        name: this.intl?.formatMessage({ id: 'Завершена' }),
        imageSrc: serviceClosed,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Количество заявок, переведённых за указанный период в статус "Завершена"',
        }),
      },
    ]

    this.reportStatuses = [
      {
        id: 1,
        name: this.intl?.formatMessage({ id: 'Создан' }),
        imageSrc: formed,
      },
      {
        id: 2,
        name: this.intl?.formatMessage({ id: 'Проверка данных' }),
        imageSrc: dataChecking,
      },
      {
        id: 3,
        name: this.intl?.formatMessage({ id: 'Уточнение данных' }),
        imageSrc: dataClarifying,
      },
      {
        id: 4,
        name: this.intl?.formatMessage({ id: 'Проверка завершена' }),
        imageSrc: dataCheckFinished,
      },
      {
        id: 5,
        name: this.intl?.formatMessage({ id: 'Отправлен' }),
        imageSrc: sent,
      },
      {
        id: 100,
        name: this.intl?.formatMessage({ id: 'Получен' }),
        imageSrc: received,
      },
      {
        id: 101,
        name: this.intl?.formatMessage({ id: 'Проверка отчёта' }),
        imageSrc: dataRechecking,
      },
      {
        id: 102,
        name: this.intl?.formatMessage({ id: 'На оплату' }),
        imageSrc: paying,
      },
      {
        id: 200,
        name: this.intl?.formatMessage({ id: 'Закрыт' }),
        imageSrc: closed,
      },
    ]

    this.serviceReportStatuses = [
      {
        id: 1,
        name: this.intl?.formatMessage({ id: 'Создан' }),
        imageSrc: serviceFormed,
      },
      {
        id: 2,
        name: this.intl?.formatMessage({ id: 'Проверка данных' }),
        imageSrc: serviceDataChecking,
      },
      {
        id: 3,
        name: this.intl?.formatMessage({ id: 'Уточнение данных' }),
        imageSrc: serviceDataClarifying,
      },
      {
        id: 4,
        name: this.intl?.formatMessage({ id: 'Проверка завершена' }),
        imageSrc: serviceDataCheckFinished,
      },
      {
        id: 5,
        name: this.intl?.formatMessage({ id: 'Отправлен' }),
        imageSrc: serviceSent,
      },
      {
        id: 100,
        name: this.intl?.formatMessage({ id: 'Получен' }),
        imageSrc: serviceReceived,
      },
      {
        id: 101,
        name: this.intl?.formatMessage({ id: 'Проверка отчёта' }),
        imageSrc: serviceDataRechecking,
      },
      {
        id: 102,
        name: this.intl?.formatMessage({ id: 'На оплату' }),
        imageSrc: servicePaying,
      },
      {
        id: 200,
        name: this.intl?.formatMessage({ id: 'Закрыт' }),
        imageSrc: serviceClosed,
      },
    ]

    this.allDataCheckingStatuses = {
      none: 0,
      checked: 1,
      needClarification: 2,
      clarified: 3,
    }

    this.dataCheckingStatuses = [
      {
        id: this.allDataCheckingStatuses.none,
        name: this.intl?.formatMessage({ id: 'Не указан' }),
        color: '#FFF',
      },
      {
        id: this.allDataCheckingStatuses.checked,
        name: this.intl?.formatMessage({ id: 'Подтверждено' }),
        color: 'rgba(22,176,37,0.2)',
      },
      {
        id: this.allDataCheckingStatuses.needClarification,
        name: this.intl?.formatMessage({ id: 'Уточняется' }),
        color: 'rgba(224,23,23,0.1)',
      },
      {
        id: this.allDataCheckingStatuses.clarified,
        name: this.intl?.formatMessage({ id: 'Уточнено' }),
        color: 'rgba(224,96,23,0.2)',
      },
    ]

    this.agreementCheckingStatuses = [
      {
        id: 0,
        name: 'Договор не предоставлен',
        imageSrc: agreementStatus0,
      },
      {
        id: 1,
        name: 'Договор сформирован',
        imageSrc: agreementStatus1,
      },
    ]
    //покак нет стора для приоритетов
    this.priorityRequestList = [
      { value: 'Без приоритета', key: 'Без приоритета' },
      { value: '0', key: '0' },
      { value: '1', key: '1' },
      { value: '2', key: '2' },
      { value: '3', key: '3' },
      { value: '4', key: '4' },
      { value: '5', key: '5' },
    ]

    this.summaryStatuses = [
      {
        id: this.allOrderStatuses.createdAtSummaryTime,
        name: this.intl?.formatMessage({ id: 'Дата создания' }),
        imageSrc: createDateIcon,
        summaryTooltip: this.intl?.formatMessage(
          {
            id: 'Количество заявок, у которых Дата создания попадает в выбранный временной период (по данным на {timeStamp})',
            defaultMessage:
              'Количество заявок, у которых Дата создания попадает в выбранный временной период (по данным на {timeStamp})',
          },
          {
            timeStamp: moment().format('DD.MM.YYYY'),
          },
        ),
      },
      {
        id: this.allOrderStatuses.installedAtSummaryTime,
        name: this.intl?.formatMessage({ id: 'Дата установки' }),
        imageSrc: installationDateIcon,
        summaryTooltip: this.intl?.formatMessage(
          {
            id: 'Количество заявок, у которых Дата установки попадает в выбранный временной период (по данным на {timeStamp})',
            defaultMessage:
              'Количество заявок, у которых Дата установки попадает в выбранный временной период (по данным на {timeStamp})',
          },
          {
            timeStamp: moment().format('DD.MM.YYYY'),
          },
        ),
      },
    ]

    makeObservable(this, {
      orderStatuses: computed,
      financialSources: computed,
      finSourceId: observable,
      xBtn: observable,
    })
  }
  finSourceId = null
  senderGroups = []
  xBtn = false

  financialSourcesName = []
  finSourceReasons = []
  allOrderStatuses = {
    created: 1,
    assigned: 2,
    accepted: 4,
    working: 5,
    installed: 6,
    impossible: 7,
    loadedByOperator: 9,
    duplicate: 10,
    uncompleted: 11,
    reporting: 12,
    dataChecking: 13,
    clarifying: 14,
    reported: 15,
    closed: 16,
    createdAtSummaryTime: 98,
    installedAtSummaryTime: 99,
  }

  allServiceOrderStatuses = {
    requested: 1,
    dealerAssigned: 2,
    solvedWithoutVisit: 3,
    acceptedByDealer: 4,
    InProgress: 5,
    impossible: 7,
    duplicate: 10,
    improvementRequired: 11,
    completeRepair: 6,

    // комплексные статусы
    repairIsDone: 6.2,
    diagnosticAndRepair: 6.3,

    // воображаемые статусы
    onSiteRepair: 6.105,
    transferToServiceCenter: 6.106,
    guaranteeRepair: 6.4,
    noGuaranteeRepair: 6.5,

    toGuaranteeRepair: 8,

    // отчетные статусы
    reporting: 12,
    dataChecking: 13,
    clarifying: 14,
    reported: 15,
    closed: 16,

    guaranteeRepairSended: 20,
    guaranteeRepairStarted: 21,
    guaranteeRepairCompleted: 22,
    guaranteeRepairRejected: 23,
  }

  get orderStatuses() {
    return [
      {
        id: this.allOrderStatuses.created,
        name: this.intl?.formatMessage({ id: 'Создана' }),
        imageSrc: newRequest,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Количество заявок, заведённых в систему в статусе "Создана" вне зависимости от фактической Даты создания заявки',
        }),
      },
      {
        id: this.allOrderStatuses.assigned,
        name: this.intl?.formatMessage({ id: 'Назначена' }),
        imageSrc: assigned,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Количество заявок, переведённых за указанный период в статус "Назначена"',
        }),
      },
      {
        id: this.allOrderStatuses.accepted,
        name: this.intl?.formatMessage({ id: 'Принята' }),
        imageSrc: accepted,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Количество заявок, переведённых за указанный период в статус "Принята"',
        }),
      },
      {
        id: this.allOrderStatuses.working,
        name: this.intl?.formatMessage({ id: 'Установка' }),
        imageSrc: installation,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Количество заявок, переведённых за указанный период в статус "Установка"',
        }),
      },
      {
        id: this.allOrderStatuses.installed,
        name: this.intl?.formatMessage({ id: 'Установлено' }),
        imageSrc: installed,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Количество заявок, переведённых за указанный период в статус "Установлено" вне зависимости от фактической Даты установки (даты подписания Акта с Абонентом)',
        }),
      },
      {
        id: this.allOrderStatuses.impossible,
        name: this.intl?.formatMessage({ id: 'Невозможно' }),
        imageSrc: incomplete,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Количество заявок, переведённых за указанный период в статус "Невозможно"',
        }),
      },
      {
        id: this.allOrderStatuses.loadedByOperator,
        name: isDealer()
          ? this.intl?.formatMessage({ id: 'Установленные ранее' })
          : this.intl?.formatMessage({
              id: 'Добавлена администратором',
            }),
        imageSrc: uploadByAdmin,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Количество заявок, переведённых за указанный период в статус "Добавлена администратором"',
        }),
      },
      {
        id: this.allOrderStatuses.duplicate,
        name: this.intl?.formatMessage({ id: 'Дубликат' }),
        imageSrc: duplicate,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Количество заявок, переведённых за указанный период в статус "Дубликат"',
        }),
      },
      {
        id: this.allOrderStatuses.uncompleted,
        name: this.intl?.formatMessage({ id: 'На доработку' }),
        imageSrc: forRevision,
        summaryTooltip: this.intl?.formatMessage({
          id: 'Количество заявок, переведённых за указанный период в статус "На доработку"',
        }),
      },
    ]
  }

  checkEquipmentStatuses = [
    {
      id: 1,
      name: 'Создана',
      imageSrc: newRequest,
    },
    {
      id: 2,
      name: 'Назначена',
      imageSrc: assigned,
    },
    {
      id: 5,
      name: 'В работе',
      imageSrc: installation,
    },
    {
      id: 6,
      name: 'Установлено',
      imageSrc: installed,
    },
  ]

  get financialSources() {
    return [
      {
        id: 1,
        name:
          this.financialSourcesName[0] ||
          this.intl?.formatMessage({ id: 'Полная дотация' }),
        imageSrc: getIconFinancialSource(1),
      },
      {
        id: 2,
        name:
          this.financialSourcesName[1] ||
          this.intl?.formatMessage({ id: 'Частичная дотация' }),
        imageSrc: getIconFinancialSource(2),
      },
      {
        id: 3,
        name:
          this.financialSourcesName[2] ||
          this.intl?.formatMessage({ id: 'За счет абонента' }),
        imageSrc: getIconFinancialSource(3),
      },
      {
        id: 4,
        name:
          this.financialSourcesName[3] ||
          this.intl?.formatMessage({ id: 'Не выбрана' }),
        imageSrc: getIconFinancialSource(4),
      },
      {
        id: 5,
        name:
          this.financialSourcesName[4] ||
          this.intl?.formatMessage({ id: 'Обмен' }),
        imageSrc: getIconFinancialSource(5),
      },
    ]
  }

  getAgreementStatus = (id) => {
    return this.checkEquipmentStatuses.find((el) => el.id === id)
  }

  setSenderGroups = (value) => {
    this.senderGroups = value
  }

  setXBtn = () => {
    this.xBtn = !this.xBtn
  }

  getFinancialSourceElement = (value) => {
    return this.financialSources.find((item) => item.id === value)
  }

  getFinancialSourceBack = () => {
    getFinancialSources().then((res) => {
      const items = res.map((item) => ({
        id: item.id,
        values: item.allowedInstallationReasons.map((item) => item.id),
      }))
      this.finSourceReasons = items.reduce((acc, curr) => {
        curr.values.forEach((el) => {
          if (!acc[el]) {
            acc[el] = [curr.id]
          } else {
            acc[el] = [...acc[el], curr.id]
          }
        })

        return acc
      }, {})
      this.financialSourcesName = res.map((item) => item.name)
    })
  }

  setFinSourceId = (value) => {
    this.finSourceId = value
  }

  getDataCheckingStatusName = (id) => {
    const statusData = this.dataCheckingStatuses.find((el) => el.id === id)
    if (statusData) {
      return statusData.name
    } else {
      return ''
    }
  }

  getDataCheckingStatuses = (options = {}) => {
    switch (true) {
      case isAdmin():
        return this.dataCheckingStatuses
      case isDealer() || isDealerOperator():
        if (options.dealerReportsFilters) {
          return this.dataCheckingStatuses.filter((status) => {
            return status.id === 0 || status.id === 3
          })
        }
        if (options.reportsFrontFilters) {
          return this.dataCheckingStatuses
        }
        return this.dataCheckingStatuses

      default:
        return []
    }
  }

  getAgreementStatusData = (id) => {
    return this.agreementCheckingStatuses.find((data) => data.id === id)
  }

  getDealerStatusName = (id) => {
    let status
    switch (id) {
      case 2:
        status = this.intl?.formatMessage({
          id: 'Назначена установщику',
        })
        break
      case 4:
        status = this.intl?.formatMessage({ id: 'Принята дилером' })
        break
      case 5:
        status = this.intl?.formatMessage({ id: 'Установка' })
        break
      case 6:
        status = this.intl?.formatMessage({ id: 'Установка завершена' })
        break
    }
    if (!status) {
      status = this.getStatusName(id)
    }
    return status
  }

  getStatusName = (id, report) =>
    (report
      ? this.reportStatuses
      : isAdmin() || isAdministration() || isDealer() || isOperator()
        ? [...this.orderStatuses, ...this.reportOrderStatuses]
        : this.orderStatuses
    ).find((el) => +el.id === +id)?.name

  getStatusImage = (id, report) =>
    (report
      ? this.reportStatuses
      : isAdmin() || isAdministration() || isDealer() || isOperator()
        ? [...this.orderStatuses, ...this.reportOrderStatuses]
        : this.orderStatuses
    ).find((el) => +el.id === +id)?.imageSrc

  getServiceOrderStatusName = (id) =>
    this.reportServiceOrderStatuses.find((el) => +el.id === +id)?.name

  getServiceOrderStatusImage = (id) => {
    if (id < 5.9 || id > 7) {
      const newId = Math.floor(id)
      return this.reportServiceOrderStatuses.find((el) => +el.id == +newId)
        ?.imageSrc
    }

    return this.reportServiceOrderStatuses.find((el) => +el.id == +id)?.imageSrc
  }

  getServiceOrderStatusName = (id) => {
    if (id < 5.9 || id > 7) {
      const newId = Math.floor(id)
      return this.reportServiceOrderStatuses.find((el) => +el.id == +newId)
        ?.name
    }

    return this.reportServiceOrderStatuses.find((el) => +el.id == +id)?.name
  }

  getReportOrderStatusName = (id) =>
    this.reportOrderStatuses.find((el) => +el.id === +id)?.name
  getReportOrderStatusImage = (id) =>
    this.reportOrderStatuses.find((el) => +el.id === +id)?.imageSrc
  getReportStatusName = (id) =>
    this.reportStatuses.find((el) => +el.id === +id)?.name
  getReportStatusImage = (id) =>
    this.reportStatuses.find((el) => +el.id === +id)?.imageSrc
  getServiceReportStatusImage = (id) =>
    this.serviceReportStatuses.find((el) => +el.id === +id)?.imageSrc

  getStatusesByRole(arg) {
    switch (true) {
      case isAdministration() && arg !== 'DEV':
        return [...this.orderStatuses, ...this.reportOrderStatuses].filter(
          (el) => [1, 7, 11].includes(el.id),
        )
      case isAdmin() || isOperator() || arg === 'DEV':
        return [...this.orderStatuses, ...this.reportOrderStatuses]
      case (isDealer() && arg !== 'DEV') ||
        (isDealerOperator() && arg !== 'DEV'):
        const intersectionForRole = new Set([
          0, 2, 4, 5, 6, 7, 11, 12, 13, 14, 15, 16,
        ])
        return [...this.orderStatuses, ...this.reportOrderStatuses].filter(
          (el) => intersectionForRole.has(el.id),
        )
      default:
        return []
    }
  }

  getServiceStatuses() {
    let result = [...this.reportServiceOrderStatuses]
    result = result.filter((status) => {
      if ([6.105, 6.106, 6.4, 6.5, 6.2, 6.3, 22, 23].includes(status.id)) {
        return false
      }
      return true
    })
    if (isDealer()) {
      result = result.filter((status) => {
        if (![1, 7, 10].includes(status?.id)) {
          return true
        }
      })
    }
    if (isAdministration()) {
      result = result.filter((status) => ![7, 10].includes(status.id))
    }
    return result
  }
}

export default StatusesStore
